import React from "react";
import styled from "styled-components";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { moneyFormat } from "./format";
import { getTeam, pickPercent } from "./utils";

// Hover-only help affordance next to the panel title. CSS-only tooltip
// (no state/JS) so it doesn't fight with recharts' animation timers.
// Reuses the same visual language as ActivationTooltip in round-admin.
const TitleWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const HelpTooltip = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 320px;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(0, 27, 59, 0.94);
  color: #ffffff;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  white-space: normal;
  text-align: left;
  opacity: 0;
  pointer-events: none;
  transition: opacity 100ms ease;
  z-index: 20;

  p {
    margin: 0 0 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

const HelpHover = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid rgba(0, 27, 59, 0.4);
  color: rgba(0, 27, 59, 0.6);
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  user-select: none;

  &:hover {
    border-color: rgba(0, 27, 59, 0.7);
    color: rgba(0, 27, 59, 0.85);
  }

  &:hover ${HelpTooltip},
  &:focus-within ${HelpTooltip} {
    opacity: 1;
  }
`;

const AwarenessTitle = () => (
  <TitleWrap>
    Awareness
    <HelpHover tabIndex={0} aria-label="What is Awareness?">
      ?
      <HelpTooltip role="tooltip">
        <p>Awareness measures how visible your product is to interested customers.</p>
        <p>Spending on the right promotional channels lifts it, but returns diminish. After a point, extra dollars don’t buy much more awareness.</p>
        <p>Awareness also fades about 25% each round, so invest every round to stay visible.</p>
      </HelpTooltip>
    </HelpHover>
  </TitleWrap>
);

const MarketingAwareness = ({
  competitiveAnalysis,
  teamId,
  incomeStatement,
  teams,
  competitionMetrics
}) => {
  const data = competitiveAnalysis || competitionMetrics;
  const team = getTeam(teamId, data);

  return (
    <OnePanelChart
      title={<AwarenessTitle />}
      chartTitle="PRODUCT AWARENESS"
      vertical
      suffix="%"
      data={pickPercent(teams, data, "Product Awareness")}
      teams={teams}
    >
      <Text>
        Your team spent {moneyFormat(-incomeStatement["Promotion Costs"])} in
        marketing to drive overall product awareness to{" "}
        {(team["Product Awareness"] * 100).toFixed(2)}%.
      </Text>
    </OnePanelChart>
  );
};

export default MarketingAwareness;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingAwareness.js